/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import "./Orderform.css";
import image1 from '../Media/pure-01.webp'
import LoadingNew from "../LoadingNew/LoadingNew";
import { getFBC, getFBP } from '../FBC/FBC';

function Orderform() {
    const [isLoading, setIsLoading] = useState(false); // Default selection
    const [selectedProduct, setSelectedProduct] = useState('২ পিস'); // Default selection
    const [price, setPrice] = useState(700); // Default price based on '1 Piece'
    const route = useNavigate()
    const productVariants = [
        { name: '২ পিস', price: 700 },
        { name: '৩ পিস', price: 900 },
    ];

    const handleProductChange = (event) => {
        const productName = event.target.value;
        setSelectedProduct(productName);
        const selectedPrice = productVariants.find((p) => p.name === productName).price || 0;
        setPrice(selectedPrice);
    };


    const [formData, setFormData] = useState({
        name: "",
        address: "",
        phone: "",
        note: ""
    });

    const unitPrice = price;
    const shippingCost = 80;
    const total = unitPrice + shippingCost;



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        const orderData = new FormData()
        orderData.append('address', formData.address)
        orderData.append('name', formData.name)
        orderData.append('phone', formData.phone)
        orderData.append('note', formData.note)
        orderData.append('products', selectedProduct)
        orderData.append('total_amount', total)
        orderData.append('price', unitPrice)
        orderData.append('delivery_fee', shippingCost)
        orderData.append('quantity', 1)
        orderData.append('product_slug', selectedProduct)

        try {
            const res = await fetch("https://backendjuice.pythonanywhere.com/api/order/create/", {
                method: "POST",
                body: orderData
            });
            if (res.ok) {
                const resData = await res.json()
                localStorage.setItem('orderData', JSON.stringify(resData))
                route('/confirm')
                setTimeout(() => {
                    setIsLoading(false)
                }, 1000);
            }
            else {
                alert("Something went wrong!");
            }

        } catch (error) {
            console.error("Order failed", error);
            alert("Something went wrong!");
        }

    };



    useEffect(() => {
        const fbPixelData = {
            value: unitPrice,
            currency: 'BDT',
            content_name: `${selectedProduct} Weight Loss Pure Slimming Juice`,
            content_price: unitPrice,
            content: `${selectedProduct} Weight Loss Pure Slimming Juice`,
            content_type: 'Product',
            client_user_agemt: window.navigator.userAgent,
            fbc: getFBC(),
            fbp: getFBP(),
        }
        ReactPixel.track('InitiateCheckout', fbPixelData);
        ReactPixel.track('ViewContent', fbPixelData);
    }, [selectedProduct, unitPrice])


    return (
        <div>
            {isLoading ? <LoadingNew /> : null}
            <div className="checkout-container">
                <h2 className="checkout-title">
                    অর্ডার করতে সঠিক তথ্য দিয়ে নিচের ফর্মটি পূরণ করুন
                </h2>

                <form className="checkout-form" onSubmit={handleSubmit}>
                    <div className="left-panel">
                        <h4> <label className='productSelectLabel'>Select Product:</label></h4>
                        <div className="">
                            <div>
                                <div className='productSelectContainer'>

                                    <div className='radioGroup'>
                                        {productVariants.map((product) => (
                                            <div style={{ display: 'flex' }} key={product.name} className='radioOption product-card'>
                                                <span className="badge">লিমিটেড অফার</span>
                                                <input
                                                    type="radio"
                                                    id={product.name}
                                                    name="product"
                                                    value={product.name}
                                                    checked={selectedProduct === product.name}
                                                    onChange={handleProductChange}
                                                    className='radioInput'
                                                />
                                                <label htmlFor={product.name} className='radioLabel'>
                                                    <div style={{ display: 'flex' }}>
                                                        <div>
                                                            <div>
                                                                <img src={image1} alt="product" />
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <p style={{ marginLeft: '5px' }} >Weight Loss Pure Slimming Juice <br />
                                                                <b> {product.name} - {product.price}</b>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            </div>



                        </div>

                        <div className="input-group">
                            <input
                                type="text"
                                name="name"
                                placeholder="আপনার নাম *"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="address"
                                placeholder="আপনার ঠিকানা- জেলা, থানা, বাজার*"
                                value={formData.address}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="phone"
                                placeholder="আপনার মোবাইল নাম্বার *"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                            <textarea
                                name="note"
                                placeholder="অর্ডার সম্পর্কিত কোনো নোট লিখুন (যদি থাকে)"
                                value={formData.note}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="shipping">সারাদেশে ডেলিভারি চার্জ: ৳ {shippingCost} টাকা</div>
                    </div>

                    <div className="right-panel">
                        <h4>Your order</h4>
                        <div className="summary-item">
                            <span>{selectedProduct} Weight Loss Juice</span>
                            <span>৳ {unitPrice} টাকা</span>
                        </div>
                        <div className="summary-item">
                            <span>সারা দেশে ডেলিভারি</span>
                            <span>৳ {shippingCost} টাকা</span>
                        </div>
                        <div className="summary-total">
                            <strong>Total</strong>
                            <strong>৳ {total.toFixed(2)}</strong>
                        </div>

                        <div className="cod-box">
                            <p>Cash on delivery</p>
                            <input type="text" value="Pay with cash upon delivery." disabled />
                        </div>

                        <button type="submit" className="place-order-btn">
                            অর্ডারটি কনফার্ম করুন ৳ {total.toFixed(2)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Orderform;
